export interface IConvertTextToSpeechBody {
  content: string;
  voice: string;
  apiKey: string;
  speed: TextToSpeechSpeed;
}

export interface IConvertTextToSpeechFptBody extends IConvertTextToSpeechBody {}
export interface IConvertTextToSpeechViettelBody extends IConvertTextToSpeechBody {}
export interface IConvertTextToSpeechVbeeBody extends IConvertTextToSpeechBody {
  appKey: string;
}

export interface IConvertTextToSpeechRes {
  url?: string;
  status: 'SUCCESS' | 'FAILURE';
  request_id: string;
  duration?: number;
  message?: string;
}

export enum TextToSpeechSpeed {
  VERY_SLOW = 'VERY_SLOW',
  SLOW = 'SLOW',
  BALANCE = 'BALANCE',
  FAST = 'FAST',
  VERY_FAST = 'VERY_FAST',
}
